import {Storage} from "@aws-amplify/storage";
import {Auth} from "aws-amplify";

function useS3() {
	const getS3Url = async ({
		path,
		config
	}) => {

		const url = await Storage.get(path, config);
		return url
	}
	const openDocument = (url, documentName='document') => {
		//let d = new Date().toISOString()
		window.open(url, documentName, "height=900,width=1030,toolbar=0,location=0,menubar=0");
	}
	const getFile = async (url) => {
		return await fetch(url).then(res => {

			return res.arrayBuffer()
		})
	}
	const put = async (path, file, config) => {
		await Auth.currentSession();        // 1️⃣ Refresh JWT if needed
		await Auth.currentCredentials();    // 2️⃣ Refresh STS creds using the new JWT
		try{
			return await Storage.put(path, file, config);
		}
		catch(e){
			try {
				// one more try
				await Auth.currentSession();
				await Auth.currentCredentials();
				return await Storage.put(path, file, config);
			} catch (err) {
				// really expired
				alert('Session expired. Please log in again.');
				await Auth.signOut();
				window.location.reload();
			}

		}

	};

	const remove = async (path, config) => {
		return await Storage.remove(path, config)
	}

	const copy = async (source, destination) => {
		return await Storage.copy(source, destination)
	}

	return {
		put,
		copy,
		getS3Url,
		openDocument,
		remove,
		getFile
	}
}

export default useS3;